import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { WorkflowService } from '../../../services/workflow.service';
import { switchMap, finalize } from 'rxjs/operators';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import permissions from 'app/models/Permissions';
import Utils from '../../../shared/utils';

@Component({
  selector: 'app-components-managecustomer-open-workflows',
  templateUrl: './open-workflows.component.html',
  styleUrls: ['./open-workflows.component.scss'],
})

export class OpenWorkflowsComponent implements OnInit {
  @Input() customerId: number;
  @Input() partner: Boo.Objects.Partner;
  @Input() user: Boo.Objects.User;

  isLoading = true;
  canCloseWorkflows = false;
  workflowToClose: Boo.Objects.Workflows.CloseableWorkflow;
  closeNote: string;
  workflows: Boo.Objects.Workflows.CloseableWorkflow[] = [];

  constructor(
    private workflowService: WorkflowService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.canCloseWorkflows = Utils.hasPermission(this.partner, this.user.PartnerUsers, permissions.CanCloseWorkflow, this.user);
    this.getWorkflows();
  }

  getWorkflows(): void {
    this.isLoading = true;
    this.workflowService.getClosableWorkflows(this.customerId)
      .pipe(
        finalize(() => this.isLoading = false)
      ).subscribe({
        next: (workflows) => {
          this.workflows = workflows;
        },
        error: (err) => toastr.error(err)
      });
  }

  openCloseWorkflowModal(content: TemplateRef<any>, workflow: Boo.Objects.Workflows.CloseableWorkflow): void {
    this.workflowToClose = workflow;
    this.modalService.open(content);
  }

  closeWorkflow(modalRef: NgbModalRef): void {
    this.closeNote = (this.closeNote ?? '').trim();
    if (!this.closeNote) {
      toastr.error('A note is required');
      return;
    }

    modalRef.dismiss();
    this.isLoading = true;
    this.workflowService.closeWorkflow(
      this.customerId,
      this.workflowToClose.WorkflowId,
      this.closeNote,
      this.workflowToClose.WorkflowCloseType,
      this.workflowToClose.ClosingTaskId,
      this.workflowToClose.WorkflowDefinition)
      .pipe(
        switchMap(() => {
          toastr.success('Workflow closed');
          this.workflowToClose = null;
          this.closeNote = null;
          return this.workflowService.getClosableWorkflows(this.customerId);
        }),
        finalize(() => this.isLoading = false)
      ).subscribe({
        next: (workflows) => {
          this.workflows = workflows;
        },
        error: (err) => toastr.error(err)
      });
  }

  closeModal(modalRef: NgbModalRef): void {
    this.closeNote = null;
    modalRef.dismiss();
  }
}
